import React from 'react';
import { Grid, FormControlLabel, Checkbox } from '@mui/material';

const TabOne = ({ dashboardData, setdashboardData, onClickAll }) => {
  return (
    <Grid container>
      <Grid item xs={12} sx={{ mt: 2 }}>
        <FormControlLabel
          id="dashboard-form-all"
          control={
            <Checkbox
              id="dashboard-all"
              checked={dashboardData.every((dash) => dash.view)}
              onClick={(e) =>
                onClickAll(dashboardData, 'status', setdashboardData, e)
              }
            />
          }
          label="All"
        />
      </Grid>
      {dashboardData.map((data, index) => {
        return (
          <Grid item xs={6}>
            <FormControlLabel
              control={
                <Checkbox
                  checked={dashboardData[index]?.view}
                  onChange={(e) => {
                    let items = [...dashboardData];
                    let item = { ...items[index] };
                    item = {
                      category: data.category,
                      name: data.name,
                      tab: data.tab,
                      view: !data.view
                    };
                    items[index] = item;
                    setdashboardData(items);
                  }}
                />
              }
              label={data.name}
            />
          </Grid>
        );
      })}
    </Grid>
  );
};

export default TabOne;
